"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatLastFirst = exports.formatFirstLast = void 0;
function formatFirstLast(name) {
    return `${name.firstName} ${name.lastName}`;
}
exports.formatFirstLast = formatFirstLast;
function formatLastFirst(name) {
    return `${name.lastName}, ${name.firstName}`;
}
exports.formatLastFirst = formatLastFirst;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9ybWF0TmFtZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9mb3JtYXROYW1lLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBLFNBQWdCLGVBQWUsQ0FBQyxJQUFlO0lBQzdDLE9BQU8sR0FBRyxJQUFJLENBQUMsU0FBUyxJQUFJLElBQUksQ0FBQyxRQUFRLEVBQUUsQ0FBQTtBQUM3QyxDQUFDO0FBRkQsMENBRUM7QUFFRCxTQUFnQixlQUFlLENBQUMsSUFBZTtJQUM3QyxPQUFPLEdBQUcsSUFBSSxDQUFDLFFBQVEsS0FBSyxJQUFJLENBQUMsU0FBUyxFQUFFLENBQUE7QUFDOUMsQ0FBQztBQUZELDBDQUVDIn0=